import React from 'react';
export const ContextForCombineFiles = React.createContext();
